import { withTranslations } from 'src/i18n/static-generation';
import { PageMetas } from 'src/types/meta';
import PaymentView from 'src/views/Payment';
export const getStaticProps = withTranslations<PageMetas>(() => ({
  props: {
    noindex: true,
    isIncidental: true,
    skipSplash: true
  }
}));
export default PaymentView;